export const initStateCategories = (
   Object.assign({
      data                  : [],
      category_name         : '',
      category_name_english : '',
      iva_enabled           : false,
      items_selected        : [],
      actionForm            : false,
      categoryId            : '',
      identifier            : ''
   })
);